import {
    FormControl, FormErrorMessage, FormHelperText, FormLabel,
    HStack, Spacer, Text, Textarea, VStack,
} from '@chakra-ui/react';
import {
    Path, Control, FieldPathByValue, FieldValues, useController, useWatch,
} from 'react-hook-form';

export function RestrictedLengthTextAreaField<TFieldValues extends FieldValues>({
    control,
    name,
    label,
    placeholder,
    maxLength,
    isRequired = false,
    formLabelProps,
    formHelperText,
    formHelperTextProps,
}: {
    control: Control<TFieldValues>;
    name: FieldPathByValue<TFieldValues, string | null> | Path<TFieldValues>;
    label?: string;
    placeholder?: string;
    maxLength: number;
    isRequired?: boolean;
    formLabelProps?: React.ComponentProps<typeof FormLabel>;
    formHelperTextProps?: React.ComponentProps<typeof FormHelperText>;
    formHelperText?: string;
}) {
    const {
        field,
        fieldState: { invalid, error },
    } = useController({
        control,
        name,
    });

    const watch: string | null = useWatch({
        control,
        name,
    });

    return (
        <FormControl isRequired={isRequired} isInvalid={invalid}>
            {label !== undefined && <FormLabel {...formLabelProps}>{label}</FormLabel>}
            <FormHelperText {...formHelperTextProps}>
                {formHelperText}
            </FormHelperText>

            <VStack align="flex-end">
                <Textarea
                    {...field}
                    h="full"
                    placeholder={placeholder}
                    fontSize="sm"
                />
            </VStack>
            <HStack align="flex-start">
                <FormErrorMessage>
                    {error && error.message}
                </FormErrorMessage>
                <Spacer />

                <Text fontSize="sm" color={(watch?.length ?? 0) > maxLength ? 'danger.500' : 'grey.500'} mt={1}>
                    {`${(watch?.length ?? 0)} / ${maxLength} characters`}
                </Text>
            </HStack>
        </FormControl>
    );
}
